import React, { FunctionComponent } from 'react';
import { useLocation } from 'react-router-dom';

import { Alert, Box } from '@mui/material';

export const ErrorPage: FunctionComponent = () => {
  const location: any = useLocation();
  const severity = location.state?.severity || 'error';
  const message =
    location.state?.message ||
    'Something went wrong. Please try again and contact administrator if ther problem still persists.';

  return (
    <Box sx={{ padding: 2 }}>
      <Alert severity={severity} sx={{ marginTop: '64px' }}>
        {message}
      </Alert>
    </Box>
  );
};
